// eslint-disable-next-line import/prefer-default-export
export enum Encryption {
  TLS = 'TLS',
  SSL = 'SSL',
}
